.#{$namespace}-card {
	--card-padding: 20px;
	--card-border-color: #{$border-light-color};
	--card-border-radius: 4px;
	--card-bg-color: #{$white-color};

	display: flex;
	flex-direction: column;
	overflow: hidden;
	color: $text-primary-color;
	background-color: var(--card-bg-color);
	border: 1px solid var(--card-border-color);
	border-radius: var(--card-border-radius);
	transition: 0.3s;

	&.is-always-shadow {
		box-shadow: 0 0 12px #{alpha-color($black-color, 12%)};
	}

	&.is-hover-shadow {
		&:hover,
		&:focus {
			box-shadow: 0 0 12px #{alpha-color($black-color, 12%)};
		}
	}

	&__header {
		// 标题和右侧操作并排；默认 block 时按钮会贴着标题
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: calc(var(--card-padding) - 2px) var(--card-padding);
		box-sizing: border-box;
		border-bottom: 1px solid var(--card-border-color);
	}

	&__body {
		flex-grow: 1;
		overflow: auto;
		padding: var(--card-padding);
	}

	&__footer {
		padding: calc(var(--card-padding) - 2px) var(--card-padding);
		box-sizing: border-box;
		border-top: 1px solid var(--card-border-color);
	}
}
